import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteVehicleData, getVehicleList, updateVehicleData, updateVehicleStatusData } from "../../redux/actions/VehicleActions";
import RoundedPagination from "../../Components/Paginate";
import FormInput from "../../Components/FormInput";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import { getDisplayDateTimeFormat } from '../../util/generalUtills'
import Preloader from "../../Components/Preloader";
import Status from "../../enums/Status";



const Dashboard = () => {
  const { t } = useTranslation();
  const tableRef = useRef();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    AuthReducer: { auth, errors, loading },
    vehicleReducer: {
      vehicleLists,
      vehiclePermissions,
      loadingVehicle,
      errorsVehicle,
      vehicleCount,
      changedVehicleStatus,
    },
  } = useSelector((state) => state);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;

  // useEffect(() => {
  //   dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
  // }, [auth, paginate, page, search, sort]);

  const fetchVehicleList = useCallback(() => {
    if (auth?.accessToken) {
      dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [auth?.accessToken, paginate, page, search, sort, dispatch]);

  useDebounce(fetchVehicleList, 500, [auth, paginate, page, search, sort]);

  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }

  }, [errors])


  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? vehicleCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleDeleteRequest = (id) => {
    swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, delete it!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteVehicleData(auth?.accessToken, id))
        }
      });
  };

  const handleStatusChangeRequest = (item, newStatus) => {
    swal.fire({
      title: "Are you sure?",
      text: `Do you want to change the status to ${newStatus}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Yes, change it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateVehicleData(auth?.accessToken,
          
          {
            vehicleNumber: item?.vehicleNumber,
          vehicleType: item?.vehicleType,
          rcExpiry: item?.rcExpiry,
          permitExpiry: item?.permitExpiry,
          insuranceExpiry: item?.insuranceExpiry,
          fitnessExpiry: item?.fitnessExpiry,
          remark: item?.remark,
          vendorId: item?.vendor?.id,
          jenId: item?.vendor?.jen?.id,
          status: newStatus,
          }
        
          ,item?.id,));
      }
    });
  };

  useEffect(() => {
    if (changedVehicleStatus.message) {
      swal.fire({
        show: true,
        // title: "Deleted!",
        text: changedVehicleStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
      dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
    }
    else if (changedVehicleStatus.message) {
      swal.fire({
        show: true,
        title: "Great !",
        text: changedVehicleStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_VEHICLE_STATUS' });
      dispatch(getVehicleList(auth?.accessToken, paginate, page, search, sort));
    }
  }, [changedVehicleStatus])



  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Vehicle"), path: "/Vehicle", active: true },
        ]}
        title={t("Vehicle")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                  <Col lg={3}>
                    {(vehiclePermissions?.filter) && (
                      <>
                        <div className="d-flex align-items-center">
                          <input
                            type="search"
                            placeholder="Search..."
                            className="form-control ms-1"
                            autoComplete="off"
                            value={search}
                            onChange={handleSearchChange}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                  <Col lg={9}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                        {(vehiclePermissions?.add) && (
                          <>
                            <Link to="/Add-Vehicle">
                              <Button variant="success">
                                <i className="mdi mdi-clipboard-plus-outline me-1"></i>Add
                              </Button>
                            </Link>
                          </>
                        )}
                        {(vehiclePermissions?.print) && (
                          <>
                            <Button variant="dark">
                              <i className="mdi mdi-printer me-1"></i>Print
                            </Button>
                          </>
                        )}
                        {(vehiclePermissions?.excel) && (
                          <>
                            <Button variant="info">
                              <i className="mdi mdi-file-excel me-1"></i>Excel
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ overflowY: 'auto', maxHeight: '500px', border: "1px solid #dee2e6" }}>
                <Table ref={tableRef} className="mb-0 table-bordered"
                  size="sm"
                  striped
                  responsive
                  id="table-to-print"
                  style={{ width: "100%", tableLayout: "auto" }}>
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Vendor</th>
                      <th>Vehicle Number</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Registered At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleLists.length === 0 ? (
                      <tr>
                        <td colSpan="6">No data found</td>
                      </tr>
                    ) : (<>
                      {vehicleLists?.map?.((item, index) => {
                        return (
                          <tr key={item.id}>
                            <th scope="row">{index + 1 + (page - 1) * paginate}</th>
                            <td>{item?.vendor?.vendorName}</td>
                            <td>{item?.vehicleNumber}</td>
                            <td>{item?.vehicleAdminUser?.name}</td>
                             <td>{item?.status === "ACTIVE" ? <Badge className={"bg-success"}>{item?.status}</Badge> : <><Badge className={"bg-danger"}>{item?.status}</Badge></>}</td>
                            <td>{getDisplayDateTimeFormat(item?.createdAt)}</td>
                            <td>
                              {(vehiclePermissions?.edit) && (
                                <>
                                  {item?.status === "ACTIVE" && (
                                    <>
                                      <Link to="#" className="action-icon text-success" onClick={() => handleStatusChangeRequest(item, "INACTIVE")}>
                                        {" "}
                                        <i className="mdi mdi-eye"></i>
                                      </Link>
                                    </>
                                  )}
                                  {item?.status === "INACTIVE" && (
                                    <>
                                      <Link to="#" className="action-icon text-warning" onClick={() => handleStatusChangeRequest(item, "ACTIVE")}>
                                        {" "}
                                        <i className="mdi mdi-eye-off"></i>
                                      </Link>
                                    </>
                                  )}

                                  <Link to={`/Update-Vehicle/${item?.id}`} className="action-icon text-info">
                                    <i className="mdi mdi-square-edit-outline"></i>
                                  </Link>
                                </>
                              )}

                              {(vehiclePermissions?.delete) && (
                                <>
                                  <Link to="#" className="action-icon text-danger" onClick={() => handleDeleteRequest(item?.id)} >
                                    {" "}
                                    <i className="mdi mdi-delete"></i>
                                  </Link>
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}</>
                    )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(vehicleCount / paginate)}</strong> </span>
                <RoundedPagination
                  currentPage={page}
                  totalPages={Math.ceil(vehicleCount / paginate)}
                  onPageChange={(pageNumber) => setPage(pageNumber)}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingVehicle && (<Preloader />)}
    </>
  );
};

export default Dashboard;
